/**
 * The product's identity, mirroring the HyperTek prototype's `BRAND` (h-prototype `src/config/app.ts`): the
 * name shown beside the logo, the line under it, and the logo itself. The logo is served from Vite's
 * `publicDir` (apps/web/public), which the build copies to the root of `dist` — the API serves it from there
 * at `/logo.png`, and the CSP's `img-src 'self'` admits it. Swap public/logo.png to rebrand.
 */
export const BRAND = {
  /** Short product name. */
  name: 'H-Operation',
  /** Sub-label under the product name. */
  subtitle: 'HyperTek',
  /** Logo served from /public. */
  logoSrc: '/logo.png',
} as const;
